import React,{useEffect, useState} from 'react'
import { RadioContainer } from '../../../../components/commons'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { CloseIcon, SwapGrayIcon, SwapIcon } from '../../../../assets/images';

const RADIO_OPTIONS = [
    {
        id: "Recently Added/Modified First",
        name: "Recently Added/Modified First",
        value:""
    },
    {
        id: "Target End Date - Ascending",
        name: "Target End Date - Ascending",
        value:"asc"
    },
    {
        id: "Target End Date - Descending",
        name: "Target End Date - Descending",
        value:"desc"
    },
    {
        id: "Job Type - A to Z",
        name: "Job Type - A to Z",
        value:"asc"
    },
    {
        id: "Job Type - Z to A",
        name: "Job Type - Z to A",
        value:"desc"
    },
    {
        id: "Jobs with Open Status First",
        name: "Jobs with Open Status First",
        value:"1"
    },
    {
        id: "Client - A to Z",
        name: "Client - A to Z",
        value:"asc"
    },
    {
        id: "Client - Z to A",
        name: "Client - Z to A",
        value:"desc"
    },
    {
        id: "Client Code - Ascending",
        name: "Client Code - Ascending",
        value:"asc"
    },
    {
        id: "Client Code - Descending",
        name: "Client Code - Descending",
        value:"desc"
    },
]

type AppProps = {
    toggle: boolean;
    setToggle: (data: boolean) => void;
    handleSorting: (data: any) => void;
    selectedData: { name: string, value: string }
    type?:string;
}
const JobsSorting = ({
    toggle,
    setToggle,
    handleSorting,
    selectedData,
    type
}: AppProps) => {
    const [sortingData, setSortingData] = useState({ name: "", value: "" })
    useEffect(()=>{
        handleSorting(sortingData)
    },[sortingData?.name])

    const handleRadioValue = (data: any) => {
        
        if (data === "Target End Date - Ascending") {
            setSortingData({ name: data, value: "asc" })
        }
        else if (data === "Target End Date - Descending") {
            setSortingData({ name: data, value: "desc" })
        }
        else if (data === "Job Type - A to Z") {
            setSortingData({ name: data, value: "asc" })
        }
        else if (data === "Job Type - Z to A") {
            setSortingData({ name: data, value: "desc" })
        }
        else if (data === "Jobs with Open Status First") {
            setSortingData({ name: data, value:"1" })
        }
        else if (data === "Recently Added/Modified First") {
            setSortingData({ name: data, value: "" })
        }
        else if (data === "Client - A to Z") {
            setSortingData({ name: data, value: "asc" })
        }
        else if (data === "Client - Z to A") {
            setSortingData({ name: data, value: "desc" })
        }
        else if (data === "Client Code - Ascending") {
            setSortingData({ name: data, value:"asc" })
        }
        else if (data === "Client Code - Descending") {
            setSortingData({ name: data, value: "desc" })
        }
        }
    return (
        <ButtonDropdown
            isOpen={toggle}
            toggle={() => {
                setToggle(!toggle)
            }}

        >
            <DropdownToggle
                caret
                color='#262a44'
                style={toggle
                    ? {
                        color: "#dd4433",
                        border: "1px solid #dd4433",
                        backgroundColor: "#fff6f5",
                    }
                    : { border: "1px solid#bfcbe1" }}
            >
                <img src={selectedData?.value ? SwapIcon : SwapGrayIcon} alt="" />
            </DropdownToggle>
            <DropdownMenu right style={{ width: "340px", padding: '15px 15px 15px' }}>
                <div className='d-flex justify-content-between mt-0 mb-0'>
                    <h5 className='text-center '>Sort</h5>
                    <div className='pointer' onClick={() => {
                        setToggle(!toggle)
                    }}>
                        <img src={CloseIcon} alt="" />
                    </div>

                </div>
                <hr className='mt-0 mb-0' />
                <div className='row d-block p-3'>
                    <div>
                        <RadioContainer
                            optionsList={type==="Open"? RADIO_OPTIONS?.filter((item)=>item.id!="Jobs with Open Status First") : RADIO_OPTIONS}
                            handleSetRadioValue={handleRadioValue}
                            radioValue={selectedData?.name?selectedData?.name:"Recently Added/Modified First"}
                            alignment="vertical"
                            backGround={true}
                        />
                    </div>
                </div>
            </DropdownMenu>
        </ButtonDropdown>
    )
}

export default JobsSorting